import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthUtilService } from '../_util/auth-util.service'

@Injectable({
  providedIn: 'root'
})
export class IsNotLoggedInGuard  {
  constructor(private _authUtilService: AuthUtilService,
    private _router: Router,
    private _route: ActivatedRoute){}

  async canActivate(): Promise<boolean>{
    if(!await this._authUtilService.isLoggedIn()) return true
    let redirect=this._router.getCurrentNavigation().extractedUrl.queryParams['redirect']
    redirect?this._router.navigate([redirect]):this._router.navigate(['/'])
    return false
  }
  async canLoad(): Promise<boolean>{
    if(!await this._authUtilService.isLoggedIn()) return true
    let redirect=this._router.getCurrentNavigation().extractedUrl.queryParams['redirect']
    redirect?this._router.navigate([redirect]):this._router.navigate(['/'])
    return false
  }
}
